import type {PosterLoadObject} from '@PosterWhiteboard/poster/poster.types';
import {getPagesArray, getPageStartAndEndTime as getPageStartAndEndTimeUtil, isPageVideo} from '@Libraries/page-object.library';

export const isPosterVideo = (posterObject: PosterLoadObject): boolean => {
  const pagesArray = getPagesArray(posterObject.pages.pagesHashMap, posterObject.pages.pageOrder);

  for (const [, pageObject] of Object.entries(posterObject.pages.pagesHashMap)) {
    const times = getPageStartAndEndTimeUtil(pagesArray, pageObject.hashedID);
    if (!times) {
      return false;
    }

    if (isPageVideo(pageObject, posterObject.audioClips, times[0], times[1])) {
      return true;
    }
  }

  return false;
};
